import { Twitter, Linkedin, MessageCircle, Link2, Check } from 'lucide-react';
import { useState } from 'react';

// Share intents only — no backend, no tracking. Copy-link uses the Clipboard
// API and falls back silently if it's unavailable (e.g. no permission).
const ShareButtons = ({ url, title }) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      // Clipboard access can be blocked; the link is still visible in the
      // address bar, so there's nothing useful to show the user here.
    }
  };

  const links = [
    { label: 'Share on X', icon: <Twitter size={16} />, href: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}` },
    { label: 'Share on LinkedIn', icon: <Linkedin size={16} />, href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}` },
    { label: 'Share on WhatsApp', icon: <MessageCircle size={16} />, href: `https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}` }
  ];

  return (
    <div className="share-row">
      <span>Share</span>
      {links.map((l) => (
        <a key={l.label} href={l.href} target="_blank" rel="noopener noreferrer" aria-label={l.label} className="share-btn">
          {l.icon}
        </a>
      ))}
      <button type="button" className="share-btn" onClick={copy} aria-label="Copy link">
        {copied ? <Check size={16} /> : <Link2 size={16} />}
      </button>
    </div>
  );
};

export default ShareButtons;
